// ─────────────────────────────────────────────
// services/notificationService.js
// SMS and email notification helpers
// Uses: Supabase Edge Functions (MIT client)
// License: MIT (your original IP)
// ─────────────────────────────────────────────

import { supabase } from "../supabase";

/** Send SMS notification via Supabase Edge Function */
export async function sendSMSNotification(type, phone, booking, requestId = null, audience = null) {
  if (!phone) return;
  try {
    // functions.invoke attaches the signed-in user's session token, which
    // send-notification requires (it rejects the bare anon key with 401).
    // Same call pattern as the booking_confirmed send in BookingFlow.js.
    const { error } = await supabase.functions.invoke("send-notification", {
      body: {
        type,
        phone,
        booking,
        request_id: requestId || booking?.request_id || null,
        audience,
      },
    });
    if (error) {
      console.warn("[SMS] send failed:", error.message || error);
    }
  } catch (e) {
    console.warn("[SMS] network error (non-fatal)");
  }
}

/** Format booking payload for notifications */
export function buildBookingPayload(req, loadTiers) {
  const tier = loadTiers.find((t) => t.key === req.size);
  return {
    date: req.date,
    window: req.pickup_window,
    size: tier?.label || req.size,
    total: req.quick ? (tier?.price || 0) + 19 : tier?.price || 0,
  };
}
